import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';

const List = ({ t, requireChildSchool, ...rest }) => {
	const columns = [
		{
			header: t('PrepaidTermsReport_Center'),
			accessor: 'center',
			sortable: true
		},
		{
			header: t('PrepaidTermsReport_SchoolYear'),
			accessor: 'schoolYear',
			sortable: true
		},
		{
			header: t('PrepaidTermsReport_Parent'),
			accessor: 'parent',
			cell: (parent, row) => (<Link to={`/parents/${row.parentId}`} > {parent}</Link>),
			sortable: true
		},
		{
			header: t('PrepaidTermsReport_Child'),
			accessor: 'child',
			cell: (child, row) => (<Link to={`/parents/${row.parentId}/children/${row.childId}`} > {child}</Link>),
			sortable: true
		}		
	];

	if (requireChildSchool) {
		columns.push({
			header: t('PrepaidTermsReport_School'),
			accessor: 'schoolName',
			sortable: true
		});
	}

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);